import {Component, OnInit, OnDestroy} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriptionStatus} from "../../model/subscription-status";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-show-subscriptions-modal',
  templateUrl: './choose-subscription-modal.html',
  styleUrls: ['./choose-subscription-modal.component.css']
})
export class ChooseSubscriptionModal implements OnInit, OnDestroy {

  privetPlus: boolean;
  privet: boolean;
  privetPlusPurchase: boolean;
  purchasing: boolean;
  requestInProgress: boolean;
  wrongServiceError: boolean;
  subscription: Subscription;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
    this.purchasing = false;
    let privetPlusStatus = this.subscriberService.subscriberValue.privetPlusStatus;
    let privetStatus = this.subscriberService.subscriberValue.privetStatus;

    this.privetPlus = privetPlusStatus == SubscriptionStatus.ACTIVE || privetPlusStatus == SubscriptionStatus.ACTIVATING;
    this.privet = privetStatus == SubscriptionStatus.ACTIVE || privetPlusStatus == SubscriptionStatus.ACTIVATING;
    this.privetPlusPurchase = true;
    this.subscription = new Subscription();
    this.wrongServiceError = false;
  }

  ngOnInit(): void {
    this.subscriberService.loadSubscriptions();

    this.subscription.add(
      this.subscriberService.subscriber.subscribe(subscriber => {
        if (subscriber) {
          this.privet = subscriber.privetStatus == SubscriptionStatus.ACTIVE || subscriber.privetStatus == SubscriptionStatus.ACTIVATING
          this.privetPlus = subscriber.privetPlusStatus == SubscriptionStatus.ACTIVE || subscriber.privetStatus == SubscriptionStatus.ACTIVATING
        }
      })
    )
  }

  close(): void {
    this.modalsService.hideModal();
  }

  buySubscriptions(): void {
    this.purchasing=true
    this.requestInProgress = true
    this.subscriberService.activateSubscriptions(this.privetPlusPurchase)
      .subscribe((status) => {
        if (status == 'MSISDN_IN_USE') {
          this.wrongServiceError = true;
        }
        this.requestInProgress = false;
        this.subscriberService.loadSubscriptions()
      })

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
